import React, { useState } from 'react';
import { Carousel, CarouselItem, CarouselControl, CarouselIndicators, CarouselCaption } from 'reactstrap';

const items = [
  {
    src: '/assets/img/carousel/contest-name-banner.png',
    mobSrc: '/assets/img/carousel/cf-4-mob.png',
    altText: 'codeforces contest banner',
    caption: 'codeforces contest banner',
    desc: 'codeforces contest banner'
  },
  {
    src: '/assets/img/carousel/codeforces777posterNew.png',
    mobSrc: '/assets/img/carousel/codeforces777posterNew.png',
    altText: 'interview banner with Nitasha',
    caption: 'interview banner with Nitasha',
    desc: 'interview banner with Nitasha'
  },

];

const HeaderCarousel = (props) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  }

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  }

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  }

  const slides = items.map((item) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.src}
      >
        <img className="d-none d-sm-block" src={item.src} alt={item.altText} width={"100%"} />
        <img className="d-block d-sm-none" src={item.mobSrc} alt={item.altText} width={"100%"} />
        {/* <div class="carousel-caption text-dark d-none d-md-block">
          <h5>{item.caption}</h5>
          <p>{item.desc}</p>
        </div> */}
      </CarouselItem>
    );
  });

  return (
    <div className="jumbotron p-0">
      <Carousel
        activeIndex={activeIndex}
        next={next}
        previous={previous}>
        <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} />
        {slides}
        <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
        <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
      </Carousel>
    </div>

  );
}

export default HeaderCarousel;